import PxoEditDemandModal       from "./PxoEditDemandModal"
import { useState, useEffect }  from "react"
import { usePxoPage }           from "../../contexts/PxoPageContext";
import api                      from "../../services/api";

export default function PxoEditDemandModalContainer (){

    const [ _demandPostData, _setDemandPostData   ] = useState({})
    const [ _newValues,      _setNewValues        ] = useState([])

    const [ _isSaving,       _setIsSaving         ] = useState(false)
    const [ _errorMessage,   _setErrorMessage     ] = useState(null)

    const { 
        handleUpdateDescargaTable,
        isModalDemandTableOpen, 
        setIsModalDemandTableOpen,
        selectedDemandTableEdit, 
        setSelectedDemandTableEdit,
        handleUpdateDemandSection,
        pxoId

    } = usePxoPage()

    const _fetchDemandTable = async () => {

        try{ 
            
            const response = await api.get(`/getDemandsByPostId/${selectedDemandTableEdit}`)
 
            const { demandPostLines, demandPostColumns } = response.data

            _setDemandPostData({ demandPostLines, demandPostColumns })

        } catch(error) {
            console.log("Error in DemandPostId search", error)
        }
    }

    const handleUpdateNewValues = async() => {
        
        _setIsSaving(true)
        _setErrorMessage(null)

        try{ 
            
            await api.put(`/updateDemands`, { 
                demands: _newValues, 
                demandPostId: selectedDemandTableEdit,
                pxoId
            })
            
            handleUpdateDescargaTable();
            handleUpdateDemandSection()
            setIsModalDemandTableOpen(false)

        } catch(error) {

            console.log("Error in DemandPostId search", error)

            const backendMessage = 
                error?.response?.data?.error 
                || error?.response?.data?.message 
                || 'Erro ao salvar as alterações. Tente novamente.'

            _setErrorMessage(backendMessage)
            
        }

        _setIsSaving(false)

    }

    const _handleCloseModal = () => {

        setIsModalDemandTableOpen(false)
        setSelectedDemandTableEdit(null)
        
        _setNewValues([])
        _setIsSaving(false)
        _setErrorMessage(null)
    }

    useEffect(() => {

        if (isModalDemandTableOpen && selectedDemandTableEdit) {
            
            _fetchDemandTable()
            _setNewValues([])
            _setIsSaving(false)
            _setErrorMessage(null)
        }

    }, [isModalDemandTableOpen, selectedDemandTableEdit])


    return (

        <PxoEditDemandModal 

            isOpen={isModalDemandTableOpen} 
            onClose={_handleCloseModal}
            demandPostData={_demandPostData}
            newValues={_newValues}
            setNewValues={_setNewValues}

            isSaving={_isSaving}
            onUpdateNewValues={handleUpdateNewValues}
            errorMessage={_errorMessage}

        />
    )
}